import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '@/hooks/useAuth';
import { Card } from '@/components/ui/card';

/**
 * Account confirmation waiting screen.
 * Replicates AngularJS confirmation.controller.ts
 *
 * - If user is already confirmed → redirect to dashboard
 * - Otherwise show waiting message
 */
export default function Confirm() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser?.isConfirmed) {
      const defaultUrl = currentUser.principalType === 'user'
        ? '/admin/companies'
        : '/shop/reports/eod';
      navigate(defaultUrl, { replace: true });
    }
  }, [currentUser, navigate]);

  return (
    <div className="container mx-auto px-4 h-full">
      <div className="flex content-center items-center justify-center h-full">
        <div className="w-full lg:w-6/12 px-4">
          <Card variant="legacy" className="p-8 text-center">
            <div className="mb-4">
              <svg className="mx-auto h-16 w-16 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h2 className="text-xl font-bold text-slate-700 mb-4">
              Tu cuenta está siendo confirmada
            </h2>
            <p className="text-slate-500 mb-6">
              Nuestro equipo te contactará en uno de los teléfonos que proporcionaste para confirmar tu cuenta.
            </p>
            <p className="text-sm text-slate-400">
              Si tienes dudas, contáctanos por WhatsApp.
            </p>
          </Card>
        </div>
      </div>
    </div>
  );
}
